import { render, staticRenderFns } from "./main_residents.vue?vue&type=template&id=1721bcdd&scoped=true"
import script from "./main_residents.vue?vue&type=script&lang=js"
export * from "./main_residents.vue?vue&type=script&lang=js"
import style0 from "./main_residents.vue?vue&type=style&index=0&id=1721bcdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1721bcdd",
  null
  
)

export default component.exports